import { PedidoService } from './pedido.service'
import { ListagemPedidoObserver } from './listagem-pedido.observer'

export class ListagemPedidoComponent {
    constructor() {
        this.service = new PedidoService();
        this.init();
    }

    init() {
        let valorPrevisaoEntrega = document.getElementById('previsao-entrega-listagem')
        if (valorPrevisaoEntrega) {
            var atualizarPrevisao = window.setInterval(() => {
                this.verificaEstimativaEntrega()
            }, 60000)
        }
    }

    verificaEstimativaEntrega() {
        let pedidos = document.getElementsByClassName('listagem__item--previsao-infos')
        if (pedidos != null) {
            return Array.prototype.forEach.call(pedidos, p => {
                this.service
                    .verificaEstimativaEntregaListagem(p.getAttribute('hash'))
                    .subscribe(new ListagemPedidoObserver(p.getAttribute('numero-pedido')))
             })
        }
    }

}


// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/pages/minha-conta/pedido/listagem-pedido.component.js